module.exports = __webpack_public_path__ + "static/img/mitaussteller_white.8a0bd97b.svg";